var App = function() {

	_Bootstrap.switchSection('app');


	url = base_url+'connect/';

    var current_action = false;



	/* ******** Clickable ******** */
	var clickable = function() {

		// submit newsletter
		$('body').on('submit', '#newsletter', function(e){
			e.preventDefault();
		});

	}();



	return {
		init: function() {
			// scroll_reveal();
			// newsletter();
			// newsletter_form();
		},

	};
}();




var Homepage = function() {


	return {
		init: function() {
			// App.scroll_reveal();
			return;
		},

	};
}();



var About = function() {



	return {
		init: function() {
			return;
		},

	};
}();




var Contact = function() {


	var initMap = function() {



		var longitude = [],
			latitude = [];

		var map_style = [
	    	{
	      		featureType: "all",
	      		elementType: "all",
	      		stylers: [
	        		{ saturation: -100 } // <-- THIS
	      		]
	    	}
		];

		$('.map:visible').each(function(key, element){
			longitude.push($(element).attr("data-longitude"));
			latitude.push($(element).attr("data-latitude"));
		});

		$.each(longitude, function(key, value) {
			var map = new google.maps.Map(document.getElementById('map_'+key), {
				center: {lat: Number(latitude[key]), lng: Number(longitude[key])},
				zoom: 13,
				streetViewControl: false,
				mapTypeControl: false,
				disableDefaultUI: false,
				scrollwheel: false,
				styles: [{
				    stylers: [{
				      saturation: -100
				    }]
				 }]
				//panTo(marker.getPosition())
			});

			var marker = new google.maps.Marker({
				position: {lat: Number(latitude[key]), lng: Number(longitude[key])},
				map: map,
			});

			// var map_styled = new google.maps.StyledMapType(map_style, { name:"Grayscale" });
		});

	};




	return {
        init: function() {
			// contact_form();
			// App.scroll_reveal();
			return;
		},
        init_map: function() {
			initMap();
		},


    };
}();



$(document).ready(function() {

	App.init();

	if($('body').hasClass('homepage')){
		Homepage.init();
	}

	if($('body').hasClass('contact')){
		Contact.init();
	}

	if($('body').hasClass('about')){
		About.init();
	}


});


$(window).on("load", function() {

	$('body').removeClass('page-in');
	// $('body').removeClass('page-loading');

	setTimeout(function(){
		$('body').scrollTop(0);
		$('body').removeClass('page-loading');
	}, 500);

});
